import React from "react";
import { compose } from 'redux';
import withShowToast from "../hocs/with_show_toast.js";

import CurrentUserUseCase from "../use_cases/users/current_user/current_user_use_case.js.jsx";
import ListAbilitiesUseCase from "../use_cases/abilities/abilities/list_abilities_use_case.js";
import ListMenusUseCase from "../use_cases/menus/menus/list_menus_use_case.js";
import LogoutUseCase from "../use_cases/sessions/logout_use_case.js";

import WebIdIdentifiedInfoClosedStorage from "../utils/web_id_identified_info_closed_storage.js";

import CurrentUserIdentificationChannel from "../channels/user/current_user_identification_channel.js";

const CurrentUserContext = React.createContext();
const { Provider, Consumer } = CurrentUserContext;

// TODO: Document it
class CurrentUserContextProvider extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      menus: []
    };

    this.channel = new CurrentUserIdentificationChannel();
  }

  componentDidMount() {
    this.reloadSubscription();
    this.loadUser();
    this.loadMenus();
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  reloadSubscription = () => {
    this.unsubscribe();
    
    this.channel.subscribe(this.onIdentificationChanged);
  }

  unsubscribe = () => {
    if(!this.channel) {
      return 
    }
    this.channel.unsubscribe();
  }

  onIdentificationChanged = (data) => {
    const { user } = data;
    const { currentUser } = this.state;
    const updatedUser = {
      ...currentUser,
      ...user
    };
    this.setState({
      currentUser: updatedUser
    })
  }

  loadUser = (onUserLoaded = undefined) => {
    CurrentUserUseCase.execute()
    .then((result) => {
      this.loadAbilities(result, onUserLoaded);
    })
    .catch((result) => {
      const { errorCode } = result;
      if(errorCode === "unauthorized") {
        WebIdIdentifiedInfoClosedStorage.clear();
      }
      this.setState({
        userOnceLoaded: true
      })
    });
  }

  loadMenus = () => {
    ListMenusUseCase.execute()
    .then((result) => {
      const { data: { menus } } = result;

      this.setState({
        menus: menus,
      });
    })
  }

  loadAbilities = (loadUserResults, onUserLoaded = undefined) => {
    ListAbilitiesUseCase.execute()
    .then((result) => {
      const { data: { user, adminDashboardAbilityInfo } } = loadUserResults;
      const { data: { abilityInfos } } = result;

      this.setState({
        currentUser: user,
        adminDashboardAbilityInfo: adminDashboardAbilityInfo,
        userOnceLoaded: true,
        abilityInfos: abilityInfos,
      });
      this.reloadSubscription();
      if(onUserLoaded) {
        onUserLoaded();
      }
    })
    .catch((result) => {
      this.setState({
        userOnceLoaded: true
      })
    });
  }

  signOut = (callback = undefined) => {
    const { loggingOut } = this.state;
    if(loggingOut) {
      return;
    }
    this.setState({
      loggingOut: true
    })
    LogoutUseCase.execute()
    .then(() => {
      WebIdIdentifiedInfoClosedStorage.clear();
      this.setState({
        loggingOut: false,
        currentUser: undefined,
        adminDashboardAbilityInfo: undefined,
        abilityInfos: undefined
      })
      this.unsubscribe();
      if(callback) {
        callback();
      }
    })
    .catch((result) => {
      this.setState({
        loggingOut: false
      });
      this.props.showErrorMessage(result.message);
    });

  }

  render() {
    const { children } = this.props;

    const { currentUser, adminDashboardAbilityInfo, menus, userOnceLoaded, abilityInfos } = this.state;

    return <Provider value = { {
        currentUser: currentUser,
        adminDashboardAbilityInfo: adminDashboardAbilityInfo,
        userOnceLoaded: userOnceLoaded,
        abilityInfos: abilityInfos,
        loadUser: this.loadUser,
        menus: menus,
        signOut: this.signOut
      } } >
      { children }
    </Provider>
  }
}

const composedProvider = compose(withShowToast)(CurrentUserContextProvider);

export { CurrentUserContext, composedProvider as CurrentUserContextProvider, Consumer as CurrentUserContextConsumer };

